/**
 * 封装fetch请求
 */

const TIMEOUT = 15000;
const DOWNLOAD_TIMEOUT = 30000;

export const miniFetch = (resolve, reject, options = {}) => {
    const { data, url } = options;
    options = {...options };
    // 无网络情况
    if (!navigator.onLine) {
        reject({ id: 'gui.alerts.networkConnectionError', defaultMessage: 'Network error, please check your network connection' });
        return;
    }
    const timeoutId = setTimeout(() => {
        reject({ id: 'gui.network.timeout', defaultMessage: 'Request timeout, please check your network connection and try again.' });
    }, TIMEOUT);
    // 跨域
    options.mode = 'cors';
    // options.host = process.env.API_HOST;
    options.host = 'https://test-api.matatalab.com';
    delete options.url;
    if (data) {
        delete options.data;
        options.body = JSON.stringify(data);
    }
    options.headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json,text/plain,*/*',
        ...options.headers
    };
    if (localStorage.getItem('token') !== null) {
        options.headers.Authorization = localStorage.getItem('token');
    }
    // const opts = {
    //     host: process.env.API_HOST,
    //     headers: {
    //         'Accept': 'application/json,text/plain,*/*', /* 格式限制：json、文本、其他格式 */
    //         'Content-Type': 'application/x-www-form-urlencoded'/* 请求内容类型 */
    //     },
    //     method: 'post',
    //     mode: 'cors'
    // };
    // if (params) {
    //     if (params.headers) {
    //         opts.headers = Object.assign(opts.headers, params.headers);
    //     }
    //     if (params.method) {
    //         opts.method = params.method;
    //     }
    //     if (params.body) {
    //         opts.body = params.body;
    //     }
    // }

    // opts.uri = opts.host + opts.url;
    fetch(options.host + url, options, { credentials: 'include' })
        .then(async response => {
            if (response.status === 401) {
                localStorage.clear();
                reject({ id: 'gui.network.noAccessPermission', defaultMessage: 'No access permission' });
            }
            const body = await response.json();
            if (response.status >= 200 && response.status < 300) {
                return resolve(body);
            }
            return reject(body);
        })
        .catch(err => {
            reject(err);
        })
        .finally(() => {
            clearTimeout(timeoutId);
        });
};

export const asyncFetch = (options = {}) => {
    const { data } = options;
    options = {...options };
    // 跨域
    options.mode = 'cors';
    // options.host = process.env.API_HOST;
    options.host = 'https://test-api.matatalab.com';

    const request = new XMLHttpRequest();
    request.open(options.method, options.host + options.url, false);
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('Accept', 'application/json');
    if (localStorage.getItem('token') !== null) {
        request.setRequestHeader('Authorization', localStorage.getItem('token'));
    }
    if (options.headers) {
        for (const key in options.headers) {
            request.setRequestHeader(key, options.headers[key]);
        }
    }
    request.setRequestHeader('mode', 'cors');
    request.send(JSON.stringify(data));
    if (request.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
    }
    if (request.status >= 200 && request.status < 300) {
        return JSON.parse(request.responseText);
    }
    return request.response;
};

const parseJSON = function(response) {
    return response.json();
};
const checkStatus = function(response) {
    if (response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
    }
    if (response.status >= 200 && response.status < 500) {
        return response;
    }
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
};

export default (options = {}) => {
    const { data, url } = options;
    options = {...options };
    // 跨域
    options.mode = 'cors';
    // options.host = process.env.API_HOST;
    options.host = 'https://test-api.matatalab.com';
    delete options.url;
    if (data) {
        delete options.data;
        options.body = JSON.stringify(data);
    }
    options.headers = {
        'Content-Type': 'application/json'
    };
    return fetch(options.host + url, options, { credentials: 'include' })
        .then(checkStatus)
        .then(parseJSON)
        .catch(err => ({ err }));
};

export const aiMiniFetch = (resolve, reject, options = {}) => {
    const { data, url } = options;
    options = {...options };
    // 无网络情况
    if (!navigator.onLine) {
        reject({ id: 'gui.alerts.networkConnectionError', defaultMessage: 'Network error, please check your network connection' });
        return;
    }
    const timeoutId = setTimeout(() => {
        reject({ id: 'gui.network.timeout', defaultMessage: 'Request timeout, please check your network connection and try again.' });
    }, TIMEOUT);
    // 跨域
    options.mode = 'cors';
    // options.host = 'https://prod-api.matatalab.com/v1/proxy';
    // options.host = 'http://localhost:8080/v1/proxy';
    options.host = 'https://prod-api.matatalab.com/';
    delete options.url;
    if (data) {
        delete options.data;
        options.body = JSON.stringify(data);
    }
    options.headers = {
        'Content-Type': 'application/json;charset=utf-8',
        'Accept': 'application/json,text/plain,*/*',
        ...options.headers
    };
    if (localStorage.getItem('edgeToken') !== null) {
        options.headers['x-jwt-token'] = localStorage.getItem('edgeToken');
    }
    // opts.uri = opts.host + opts.url;
    fetch(`${options.host}${url}`, options, { credentials: 'include' })
        .then(async response => {
            clearTimeout(timeoutId);
            if (response.status === 401) {
                localStorage.clear();
                reject(401);
            }
            const body = await response.json();
            if (response.status >= 200 && response.status < 300) {
                return resolve(body);
            }
            return reject(body);
        })
        .catch(err => {
            clearTimeout(timeoutId);
            reject(err);
        });
};

export const aiMiniFetch2 = (resolve, reject, options = {}) => {
    const { data, url } = options;
    options = {...options };
    // 无网络情况
    if (!navigator.onLine) {
        reject({ id: 'gui.alerts.networkConnectionError', defaultMessage: 'Network error, please check your network connection' });
        return;
    }
    const timeoutId = setTimeout(() => {
        reject({ id: 'gui.network.timeout', defaultMessage: 'Request timeout, please check your network connection and try again.' });
    }, TIMEOUT);
    // 跨域
    options.mode = 'cors';
    // options.host = 'https://prod-api.matatalab.com/v1/proxy/training';
    // options.host = 'http://localhost:8080/v1/proxy/training';
    options.host = 'https://ingestion.edgeimpulse.com';
    delete options.url;
    if (data) {
        delete options.data;
        options.body = JSON.stringify(data);
    }
    options.headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json,text/plain,*/*',
        ...options.headers
    };
    if (localStorage.getItem('edgeToken') !== null) {
        options.headers['x-jwt-token'] = localStorage.getItem('edgeToken');
    }

    // opts.uri = opts.host + opts.url;
    fetch(`${options.host}${url}`, options, { credentials: 'include' })
        .then(async response => {
            clearTimeout(timeoutId);
            if (response.status === 401) {
                localStorage.clear();
                reject(401);
            }
            const body = await response.text();
            if (response.status >= 200 && response.status < 300) {
                return resolve(body);
            }
            return reject(body);
        })
        .catch(err => {
            clearTimeout(timeoutId);
            reject(err);
        });
};

export const download = (resolve, reject, options = {}) => {
    const { data, url } = options;
    options = {...options };
    // 无网络情况
    if (!navigator.onLine) {
        reject(new Error('network error'));
        return;
    }
    // const timeoutId = setTimeout(() => {
    //     console.log('下载超时');
    //     reject(new Error('fetch timeout'));
    // }, DOWNLOAD_TIMEOUT);
    // 跨域
    options.mode = 'cors';
    options.host = 'https://studio.edgeimpulse.com';
    delete options.url;
    if (data) {
        delete options.data;
        options.body = JSON.stringify(data);
    }
    options.headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json,text/plain,*/*',
        ...options.headers
    };
    if (localStorage.getItem('edgeToken') !== null) {
        options.headers['x-jwt-token'] = localStorage.getItem('edgeToken');
    }
    Promise.race([
            fetch(options.host + url, options, { credentials: 'include' }),
            new Promise((_, reject) =>
                setTimeout(() => {
                    reject(new Error('fetch timeout'));
                }, DOWNLOAD_TIMEOUT)
            )
        ])
        .then(response => {
            if (response.status === 401) {
                localStorage.clear();
                reject(401);
            }
            response.blob()
                .then(blob => resolve(blob));
        })
        .catch(err => {
            reject(err);
        });
    // opts.uri = opts.host + opts.url;
    // fetch(options.host + url, options, {credentials: 'include'})
    //     .then(response => {
    //         clearTimeout(timeoutId);
    //         if (response.status === 401) {
    //             localStorage.clear();
    //             reject(401);
    //         }
    //         response.blob()
    //             .then(blob => resolve(blob));
    //     })
    //     .catch(err => {
    //         reject(err);
    //     })
    //     .finally(() => {
    //         console.log('call');
    //         clearTimeout(timeoutId);
    //     });
};


export const originAIprojectMiniFetch = (resolve, reject, options = {}) => {
    const { data, url } = options;
    options = {...options };
    // 无网络情况
    if (!navigator.onLine) {
        reject(new Error('network error'));
        return;
    }
    // 跨域
    options.mode = 'cors';
    // options.host = process.env.API_HOST;
    options.host = options.host || 'https://ingestion.edgeimpulse.com';
    // options.host = 'http://localhost:8080/v1/proxy/training';
    delete options.url;
    if (data) {
        delete options.data;
        options.body = data;
    }
    options.headers = {
        // 'Content-Type': 'application/json',
        // 'Accept': 'application/json,text/plain,*/*',
        ...options.headers
    };
    // if (localStorage.getItem('token') !== null) {
    //     options.headers.Authorization = localStorage.getItem('token');
    // }
    if (localStorage.getItem('edgeToken') !== null) {
        options.headers['x-jwt-token'] = localStorage.getItem('edgeToken');
    }
    // opts.uri = opts.host + opts.url;
    fetch(`${options.host}${url}`, options, { credentials: 'include' })
        .then(async response => {
            if (response.status === 401) {
                localStorage.clear();
                reject(401);
            }
            const body = await response.json();
            if (response.status >= 200 && response.status < 300) {
                return resolve(body);
            }
            return reject(body);
        })
        .catch(err => reject(err));
};

// 上传文件
export const updateMiniFetch = (resolve, reject, options = {}) => {
    const { data, url } = options;
    options = {...options };
    // 无网络情况
    if (!navigator.onLine) {
        reject(new Error('network error'));
        return;
    }
    // 跨域
    options.mode = 'cors';
    // options.host = process.env.API_HOST;
    options.host = 'https://test-api.matatalab.com';
    // options.host = options.host || 'https://ingestion.edgeimpulse.com';
    // options.host = 'http://localhost:8080/v1/proxy/training';
    delete options.url;
    if (data) {
        delete options.data;
        options.body = data;
    }
    options.headers = {
        // 'Content-Type': 'application/json',
        // 'Accept': 'application/json,text/plain,*/*',
        ...options.headers
    };
    if (localStorage.getItem('token') !== null) {
        options.headers.Authorization = localStorage.getItem('token');
    }
    // if (localStorage.getItem('edgeToken') !== null) {
    //     options.headers['x-jwt-token'] = localStorage.getItem('edgeToken');
    // }
    // opts.uri = opts.host + opts.url;
    fetch(`${options.host}${url}`, options, { credentials: 'include' })
        .then(async response => {
            if (response.status === 401) {
                localStorage.clear();
                reject(401);
            }
            const body = await response.json();
            if (response.status >= 200 && response.status < 300) {
                return resolve(body);
            }
            return reject(body);
        })
        .catch(err => reject(err));
};

// 嵌入式训练 数据太多超时问题
export const trainMiniFetch = (resolve, reject, options = {}) => {
    const { data, url } = options;
    options = {...options };
    // 无网络情况
    if (!navigator.onLine) {
        reject({ id: 'gui.alerts.networkConnectionError', defaultMessage: 'Network error, please check your network connection' });
        return;
    }
    const timeoutId = setTimeout(() => {
        reject({ id: 'gui.network.timeout', defaultMessage: 'Request timeout, please check your network connection and try again.' });
    }, 30000);
    // 跨域
    options.mode = 'cors';
    // options.host = process.env.API_HOST;
    options.host = 'https://test-api.matatalab.com';
    delete options.url;
    if (data) {
        delete options.data;
        options.body = JSON.stringify(data);
    }
    options.headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json,text/plain,*/*',
        ...options.headers
    };
    if (localStorage.getItem('token') !== null) {
        options.headers.Authorization = localStorage.getItem('token');
    }
    fetch(options.host + url, options, { credentials: 'include' })
        .then(async response => {
            if (response.status === 401) {
                localStorage.clear();
                reject({ id: 'gui.network.noAccessPermission', defaultMessage: 'No access permission' });
            }
            const body = await response.json();
            if (response.status >= 200 && response.status < 300) {
                return resolve(body);
            }
            return reject(body);
        })
        .catch(err => {
            reject(err);
        })
        .finally(() => {
            clearTimeout(timeoutId);
        });
};